"use strict";
module.exports = {
    entityModel: 'user',
    events: {
        USER_UPDATED: 'USER_UPDATED',
        USER_CREATED: 'USER_CREATED',
        USER_DISABLED: 'USER_DISABLED',
        USER_ENABLED: 'USER_ENABLED',
        USER_JOINED_ORGANIZATION: 'USER_JOINED_ORGANIZATION',
        USER_PASSWORD_CHANGED: 'USER_PASSWORD_CHANGED',
        USER_REQUIRED_CHANGE_PASSWORD: 'USER_REQUIRED_CHANGE_PASSWORD',
        USER_VALIDATED: 'USER_VALIDATED',
        USER_LOGGED_IN: 'USER_LOGGED_IN',
    },
    actions: {
        get: 'v1.user.get',
        list: 'v1.user.list',
        register: 'v1.user.register',
        writeUser: 'v1.user.writeUser',
        editUser: 'v1.user.editUser',
        changePassword: 'v1.user.changePassword',
        verify: 'v1.user.verify',
        disable: 'v1.user.disable',
        enable: 'v1.user.enable',
        forgotPassword: 'v1.user.forgotPassword',
        resetPassword: 'v1.user.resetPassword',
        resolveToken: 'v1.user.resolveToken',
        changeActiveOrganization: 'v1.user.changeActiveOrganization',
        endImpersonation: 'v1.user.endImpersonation',
        login: 'v1.user.login',
        socialLogin: 'v1.user.socialLogin',
        me: 'v1.user.me',
        upsert: 'v1.user.upsert',
        upsertWhenEmpty: 'v1.user.upsertWhenEmpty',
        updateWhenEmpty: 'v1.user.updateWhenEmpty',
        update: 'v1.user.update',
    },
    roles: {
        super: 'super',
        qvantiSupplierRoleSupplierAdmin: 'qvantiSupplierRoleSupplierAdmin',
        supplier: 'supplier',
        qvantiSupplierRoleArticleChanges: 'qvantiSupplierRoleArticleChanges',
        qvantiSupplierRoleOrderAcceptance: 'qvantiSupplierRoleOrderAcceptance',
        qvantiSupplierRolePriceChanges: 'qvantiSupplierRolePriceChanges',
        qvantiSupplierRoleCustomerChanges: 'qvantiSupplierRoleCustomerChanges',
    },
    ofcAccesses: {},
};
